import { render, staticRenderFns } from "./Cubes.vue?vue&type=template&id=0c7f4540&scoped=true"
import script from "./Cubes.vue?vue&type=script&lang=js"
export * from "./Cubes.vue?vue&type=script&lang=js"
import style0 from "./Cubes.vue?vue&type=style&index=0&id=0c7f4540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f4540",
  null
  
)

export default component.exports